import { render, staticRenderFns } from "./ApplySandbox.vue?vue&type=template&id=03d186e8"
import script from "./ApplySandbox.vue?vue&type=script&lang=js"
export * from "./ApplySandbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports